// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.priceListSearch',{
        url: '/pricelist?currentPage&filter&pageSize',
        views: {'productList@product': {
            templateUrl: 'main/product/articles/pricelistmgmt.tpl.html',
            controller: 'PriceListManagementController as vm'
        }},
        resolve: {
            searchTerms: searchTermResolver
        }
    });
}

// @ngInject
function searchTermResolver($stateParams) {
    return {
        filter: $stateParams.filter,
        currentPage: $stateParams.currentPage,
        pageSize: $stateParams.pageSize
    };
}

// @ngInject
function PriceListManagementController($state, searchTerms) {
    var vm = this;

    //Properties
    vm.articles = [];
    vm.filter = '';
    vm.currentPage = 1;
    vm.pageSize = 15;
    vm.totalItems = [];

    //Methods
    vm.selectArticle = selectArticle;

    activate();

    function activate() {
        vm.filter = searchTerms.filter ? searchTerms.filter : '';
        vm.currentPage = searchTerms.currentPage > 1 ? searchTerms.currentPage : 1;
        vm.pageSize = searchTerms.pageSize >= 20 ? searchTerms.pageSize : 20;
    }

    function selectArticle(article) {
        $state.go('product.priceListSearch.pricelist',
            {
                articleId: article.articleId,
                filter: article.searchTerms.filter,
                currentPage: article.searchTerms.currentPage,
                pageSize: article.searchTerms.pageSize
            }
        );
    }
}

angular
    .module('product.pricelistmgmt', ['product.articles.pricelist', 'product.articles.articleLabelsPrintDialog', 'product.articles.articleNewIntrastatDialog'])
    .config(stateConfig)
    .controller('PriceListManagementController', PriceListManagementController);
